import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/phase2/Phase2Home.vue'),
    },
    {
      path: '/noxh-giai-doan-2/thong-tin-khach-hang/:applicationId',
      name: 'phase2-customer-info',
      component: () => import('@/views/phase2/Phase2CustomerInfo.vue'),
    },
    {
      path: '/noxh-giai-doan-2/cap-nhat-thong-tin/:applicationId',
      name: 'phase2-customer-update',
      component: () => import('@/views/phase2/Phase2CustomerUpdate.vue'),
    },
    {
      path: '/noxh-giai-doan-2/dang-ky-code',
      name: 'phase2-code-registration',
      component: () => import('@/views/phase2/Phase2CodeRegistration.vue'),
    },
    {
      path: '/boctham/:code',
      name: 'boctham',
      component: () => import('@/views/boctham/BocthamProcess.vue'),
    },
    // {
    //   path: '/report',
    //   name: 'boctham-report',
    //   component: () => import('@/views/boctham/BocthamReport.vue'),
    // },
    {
      path: '/upload-cam-ket/:code',
      name: 'upload-commitment',
      component: () => import('../views/customers/UploadCommitment.vue'),
    },
    {
      path: '/verify-token/:code',
      name: 'verify-token',
      component: () => import('../views/customers/VerifyToken.vue'),
    },
    {
      path: '/contract/:code/:token',
      name: 'contract-public',
      component: () => import('../views/contract/ContractPublic.vue'),
    },
    {
      path: '/thanh-toan-2/:token',
      name: 'contract-phase2-upload',
      component: () => import('../views/contract/Phase2PaymentUpload.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/common/NotFound.vue'),
    },
    {
      path: '/admin',
      redirect: '/admin/dashboard',
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: () => import('@/views/admin/Login.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/admin/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('@/views/admin/Users.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/customers',
      name: 'admin-customers',
      component: () => import('@/views/admin/Customers.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/boctham',
      name: 'admin-boctham',
      component: () => import('@/views/admin/Boctham.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/rooms',
      name: 'admin-rooms',
      component: () => import('@/views/admin/Rooms.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/email-logs',
      name: 'admin-email-logs',
      component: () => import('@/views/admin/EmailLogs.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/deposit-notification',
      name: 'admin-deposit-notification',
      component: () => import('@/views/admin/DepositNotification.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contract-signing-notification',
      name: 'admin-contract-signing-notification',
      component: () => import('@/views/admin/ContractSigningNotification.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contract-ok-completion-scope-email',
      name: 'admin-contract-ok-completion-scope-email',
      component: () => import('@/views/admin/ContractOkCompletionScopeEmail.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/customer-apartments',
      name: 'admin-customer-apartments',
      component: () => import('@/views/admin/CustomerApartments.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contracts',
      name: 'admin-contracts',
      component: () => import('@/views/contract/Contracts.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/contracts/:id/check',
      name: 'admin-contract-check',
      component: () => import('@/views/contract/ContractCheck.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/contract-payments',
      name: 'admin-contract-payments',
      component: () => import('@/views/admin/ContractPayments.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/phase2-code-registrations',
      name: 'admin-phase2-code-registrations',
      component: () => import('@/views/admin/Phase2CodeRegistrations.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/checker-applications/:id',
      name: 'admin-checker-application-review',
      component: () => import('@/views/admin/CheckerApplicationReview.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/checker-applications',
      name: 'admin-checker-applications',
      component: () => import('@/views/admin/CheckerApplications.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/gemini-api-monitor',
      name: 'admin-gemini-api-monitor',
      component: () => import('@/views/admin/AdminGeminiApiMonitor.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contract-payments/:id/history',
      name: 'admin-contract-payment-history',
      component: () => import('@/views/admin/ContractPaymentHistory.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
  ],
})

// Navigation guards
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  // console.log('Router guard - to:', to.path, 'isAuthenticated:', authStore.isAuthenticated, 'requiresAuth:', to.meta.requiresAuth, 'user:', authStore.user, 'token:', authStore.token)

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // console.log('Redirecting to login - not authenticated')
    next('/admin/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    // console.log('Redirecting to dashboard - already authenticated')
    next('/admin/dashboard')
  } else if (to.meta.requiresAdmin) {
    // Kiểm tra role admin
    const userRole = authStore.user?.role
    if (userRole !== 'admin') {
      // Nếu không phải admin, chuyển về dashboard
      next('/admin/dashboard')
    } else {
      next()
    }
  } else {
    // console.log('Allowing navigation to:', to.path)
    next()
  }
})

export default router
